export enum EAirSegment {
  CONSOL = 'Consol',
  DIRECT_AWB = 'Direct AWB',
  EXPRESS = 'Express',
  INLAND_HAULAGE = 'Inland Haulage',
  PARCEL = 'Parcel',
}
